class HyCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.buttons = [...this.querySelectorAll('[data-go]')];
    this.index = 0;
    this.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go));
      if (button.hasAttribute('data-prev')) this.show(this.index - 1);
      if (button.hasAttribute('data-next')) this.show(this.index + 1);
    });
    this.addEventListener('shopify:block:select', event => {
      const index = this.slides.findIndex(slide => slide.contains(event.target));
      if (index >= 0) this.show(index);
    });
  }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.hidden = i !== this.index;
      slide.classList.toggle('is-active', i === this.index);
    });
    this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
  }
}
class HyProjects extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.cards = [...this.querySelectorAll('.hy-project')];
    this.addEventListener('click', event => {
      const button = event.target.closest('.hy-project-select');
      if (button) this.activate(button.closest('.hy-project'));
    });
    this.addEventListener('keydown', event => {
      const button = event.target.closest('.hy-project-select');
      if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let index = this.cards.indexOf(button.closest('.hy-project'));
      if (event.key === 'ArrowLeft') index--;
      if (event.key === 'ArrowRight') index++;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = this.cards.length - 1;
      const card = this.cards[(index + this.cards.length) % this.cards.length];
      this.activate(card);
      card.querySelector('button').focus();
    });
    this.media = window.matchMedia('(max-width: 799px)');
    this.updateStates = () => this.cards.forEach(card => {
      card.querySelector('button').setAttribute('aria-expanded', String(this.media.matches || card.classList.contains('is-active')));
      card.querySelector('.hy-project-copy').setAttribute('aria-hidden', String(!this.media.matches && !card.classList.contains('is-active')));
    });
    this.media.addEventListener('change', this.updateStates);
    this.updateStates();
  }
  activate(selected) {
    if (this.media.matches) return;
    this.cards.forEach(card => card.classList.toggle('is-active', card === selected));
    this.updateStates();
  }
  disconnectedCallback() { this.media?.removeEventListener('change', this.updateStates); this.ready = false; }
}
class HyInquiry extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form = this.querySelector('form');
    this.reference = this.querySelector('.hy-reference');
    this.refInput = this.querySelector('[data-reference-input]');
    this.querySelector('[data-remove-reference]')?.addEventListener('click', () => this.setReference(''));
    this.onReference = event => this.setReference(event.detail);
    document.addEventListener('hy:reference', this.onReference);
    const queryReference = new URLSearchParams(window.location.search).get('reference');
    if (queryReference) this.setReference(queryReference);
    this.form.addEventListener('submit', () => {
      const body = this.form.querySelector('textarea');
      if (!body.value.trim()) body.value = this.form.querySelector('select').value;
      const submit = this.form.querySelector('[data-submit]');
      submit.disabled = true;
      submit.textContent = submit.dataset.sending;
      this.form.setAttribute('aria-busy', 'true');
    });
    this.onPageShow = () => {
      const submit = this.form.querySelector('[data-submit]');
      submit.disabled = false;
      submit.textContent = this.submitLabel;
      this.form.removeAttribute('aria-busy');
    };
    this.submitLabel = this.form.querySelector('[data-submit]').textContent;
    window.addEventListener('pageshow', this.onPageShow);
  }
  setReference(text) {
    const value = String(text || '').slice(0, 200);
    this.reference.hidden = !value;
    this.querySelector('[data-reference-text]').textContent = value;
    this.refInput.value = value;
  }
  disconnectedCallback() {
    document.removeEventListener('hy:reference', this.onReference);
    window.removeEventListener('pageshow', this.onPageShow);
    this.ready = false;
  }
}
if (!customElements.get('hy-carousel')) customElements.define('hy-carousel', HyCarousel);
if (!customElements.get('hy-projects')) customElements.define('hy-projects', HyProjects);
if (!customElements.get('hy-inquiry')) customElements.define('hy-inquiry', HyInquiry);
document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  if (link.dataset.reference) document.dispatchEvent(new CustomEvent('hy:reference', { detail: link.dataset.reference }));
  if (link.hash === '#inquiry' && document.getElementById('inquiry-title')) {
    requestAnimationFrame(() => document.getElementById('inquiry-title').focus({ preventScroll: true }));
  }
  if (link.closest('.hy-mobile-menu')) link.closest('details').open = false;
});

const hyHeaderState = () => document.body.classList.toggle('hy-scrolled', window.scrollY > 70);
window.addEventListener('scroll', hyHeaderState, { passive: true });
hyHeaderState();
